<!--
 * @Description: 配合 NaVerticalslot.vue 使用
-->
<template>
  <div class="cusLeftMenuItem">
    <Tooltip :content="data.label" placement="right" theme="light" max-width="200" transfer>
      <i class="iconfont icon" :class="`icon-oms2_menu_${data.id}`"></i>
    </Tooltip>
    <div class="navigator-primary-menu-div">
      <span class="displayNone">{{ data.label }}</span>
    </div>
    <Icon class="displayNone" type="ios-arrow-forward" />
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "NavigatorSubMenu",
  props: {
    data: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  mounted () {
    const _this = this
    setTimeout(() => {
      this.data.menuId == this.menuLists[0].menuId && _this.getImg() // 仅在第一个中心菜单挂载时调接口
    }, 100);
    // _.throttle(_this.getImg(), 3000)
  },
  computed: {
    ...mapState('global', ['menuLists']),
    ...mapState('customize', ['cusImgs']),
  },
  methods: {
    getImg() {
      const _this = this;
      const data = {
        type: 1,
        terminal: 'web',
      };
      _this.service.systemConfig.getPictureList(data).then((res) => {
        const { code, data } = res.data;
        if (code == 0) {
          let hasUnfoldImg = data.find(i => i.NATURE == 11 && i.URL != '') // 是否有LOGO图片
          if ($('.NavigatorVertical .right').length == 0) {
            const fragment = document.createDocumentFragment();
            const right = document.createElement('div');
            right.className = 'right'
            // const right_content = `<div class="right_content--img"></div><div class="right_content--text">伯俊全渠道业务中台</div>`;
            const right_content = `<div class="right_content--img ${hasUnfoldImg ? '' : 'default'}"></div>`; // 避免LOGO图片变更闪烁
            right.innerHTML = right_content
            fragment.appendChild(right)
            $('.NavigatorVertical').prepend(fragment)
            $('.NavigatorVertical .left').css('height', 0)
          }

          _this.$store.commit('customize/setCusImgs', data)
          data.forEach(it => {
            if (it.URL) {
              switch (it.NATURE) {
                case 10:
                  $('.NavigatorVertical .left').css('background-image', `url(${it.URL})`)
                  break;
                case 11:
                  $('.NavigatorVertical .right .right_content--img').css('background-image', `url(${it.URL})`)
                break;
                case 12:
                  $('#content .welcomepage').css('background-image', `url(${it.URL})`)
                break;
                default:
                  break;
              }
            }
          });
        }
      });
    }
  },
}
</script>
<style lang="less">
.NavigatorVertical .left img.banner {
    display: none;
  }
.NavigatorVertical {
  // 提示图标
  .ark-tooltip,
  .ark-tooltip-rel {
    width: 20px !important;
    margin-right: 10px;
    line-height: 20px;
  }
  .ark-tooltip-light.ark-tooltip-popper[x-placement="right"]
    .ark-tooltip-arrow {
    width: 0;
  }
  &.transferLeft,
  &.transferRight {
    .left, .right {
      padding: 0 !important;
      flex-grow: 0;
      flex-shrink: 0;
      background-position: center;
      background-size: contain;
      background-color: var(--b1-color);
      background-repeat: no-repeat;

    }
    .navigator-primary-menu {
      padding: 16px 20px !important;
      .cusLeftMenuItem {
        i.iconfont {
          font-size: 20px;
          -webkit-text-stroke-width: 0.2px;
          &.iconios-arrow-forward {
            font-size: 16px;
            line-height: 20px;
          }
        }
      }
      .navigator-primary-menu-div {
        height: 20px;
        line-height: 20px;
      }
    }
  }
  // 收起
  &.transferLeft {
    width: 55px !important;
    overflow: inherit;
    transition: inherit !important;
    .left {
      // background: url("~assetsImg/mini-logo.png") center no-repeat var(--b1-color);
      height: 48px !important;
      background-image: url("~assetsImg/mini-logo.png");
      // background-size: 70px;
    }
    .right {
      display: none;
    }
    .middle {
      overflow: inherit;
    }
    .displayNone {
      display: none;
    }
    .navigator-primary-menu {
      &:hover {
        .navigator-primary-menu-div .tips {
          display: block;
        }
      }
      .navigator-primary-menu-div {
        overflow: inherit;
      }
    }
    .ark-tooltip-light {
      z-index: 99999;
      .ark-tooltip-inner {
        width: 80px;
        line-height: 20px;
      }
    }
  }
  // 展开
  &.transferRight {
    width: 170px !important;
    transition: inherit !important;
    .right {
      background: none;
      display: flex;
      justify-content: space-around;
      align-items: center;
      background-color: var(--b1-color);
      position: relative;
      height: 48px;
      cursor: pointer;
      width: 227px;
      box-sizing: border-box;
      // background: url("~assetsImg/banner.png") center no-repeat var(--b1-color);
      // background-image: url("~assetsImg/banner.png");
      // background-size: 55%;
      .right_content--img {
        // width: 50px;
        height: 48px;
        background-position: center;
        // background-size: 60px;
        // background-color: var(--b1-color);
        background-repeat: no-repeat;
        // width: 195px;
        width: 98%;
        background-size: contain;
        transform: translateY(-50px);
        filter: drop-shadow(var(--t-text) 0 50px);
      }
      .right_content--img.default {
        background-image: url("~assetsImg/right-logo-blank.png"); // 默认图片
      }
      .right_content--text {
        color: #fff;
        font-size: 16px;
        width: 145px;
        height: 22px;
        line-height: 22px;
      }
    }
    .left {
      // display: none; // 用该属性会导致首次进页面时左上角闪动，所以用height控制
      height: 48px;
    }
    .ark-tooltip,
    .ark-tooltip-rel {
      pointer-events: none;
    }
  }
  // 展开部分
  div .NavigatorSubMenu {
    width: auto !important;
    top: 51px !important;
    height: calc(100% - 51px);
    max-height: initial;
    box-shadow: 16px 0 10px 0 rgba(0, 0, 0, 0.05) !important;
  }
}

body.Firefox {
  .NavigatorVertical.transferRight .right .right_content--img {
    // filter属性，原元素移出可视区后，折射的背景也消失了 -- Firefox
    transform: translateY(-39px);
    filter: drop-shadow(var(--t-text) 0 39px);
  }
}
</style>
